// extracted by mini-css-extract-plugin
export default {"wrap":"OrderDetailsRight_wrap__7d8Ga","actionButtons":"OrderDetailsRight_actionButtons__2D5R7","totalCost":"OrderDetailsRight_totalCost__vUe2b"};